'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var jwt = _interopDefault(require('jsonwebtoken'));

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var validateAuthToken = function validateAuthToken(jwtToken, publicKey) {
	try {
		// Public key needs to be in PEM format for the jsonwebtoken lib so this is why we have the following
		var key = '-----BEGIN PUBLIC KEY-----' + publicKey + '-----END PUBLIC KEY-----';

		return jwt.verify(jwtToken, key);
	} catch (error) {
		return { error: error.message };
	}
};

var decodeAuthToken = function decodeAuthToken(jwtToken, options) {
	try {
		return jwt.decode(jwtToken, _extends({}, options));
	} catch (error) {
		return { error: error.message };
	}
};

exports.validateAuthToken = validateAuthToken;
exports.decodeAuthToken = decodeAuthToken;
